import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { P } from '@angular/core/src/render3';

type UserFields = 'email' | 'password';
type FormErrors = { [u in UserFields]: string };

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  rememberMe: boolean;
  userForm: FormGroup;
  passReset = false;
  passwordResetView = false;
  formErrors: FormErrors = {
    email: '',
    password: ''
  };
  passwordError = null;
  validationMessages = {
    email: {
      required: 'Email is required.',
      email: 'Email must be a valid email'
    },
    password: {
      required: 'Password is required.',
      pattern: 'Password must be include at one letter and one number.',
      minlength: 'Password must be at least 4 characters long.',
      maxlength: 'Password cannot be more than 40 characters long.'
    }
  };

  constructor(
    private fb: FormBuilder,
    public auth: AuthService,
    private router: Router
  ) {
    this.buildForm();
  }

  ngOnInit() {
    this.buildForm();
    var _user = this.auth.getCurrentUser();
    _user.subscribe(
      done => {
        if (done) {
          this.navigateToHome();
        }
      },
      error => {
        console.log('login error', error);
      }
    );
  }
  login() {
    var emailID = (document.getElementById('emailTXT') as HTMLInputElement)
      .value;
    var pass = (document.getElementById('passwordTXT') as HTMLInputElement)
      .value;

    this.auth
      .setPersistentState(this.userForm.controls['rememberMe'].value)
      .then(value => {
        console.log('reached');
        this.auth
          .emailLogin(emailID, pass, (error) => {
            this.passwordError = error.message;
          })
          .catch(error => {
            console.log('error' + error);
          })
          .then(result => {
            console.log('result' + result);
            // this.passwordError = null;
            //this.navigateToHome();
          });
      })
      .catch(value => {
        console.log('reached error');
      });
  }
  togglePasswordRestView() {
    this.passwordResetView = !this.passwordResetView;
  }
  resetPassword() {
    this.auth
      .resetPassword(this.userForm.value['email'])
      .then(() => {
        this.passReset = true;
      }).catch(error => {
        console.log(error);
      });
  }
  buildForm() {
    this.userForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
          Validators.minLength(8),
          Validators.maxLength(32)
        ]
      ],
      rememberMe: false
    });

    this.userForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // reset validation messages
  }
  // Updates validation state on form changes.
  onValueChanged(data?: any) {
    if (!this.userForm) {
      return;
    }
    const form = this.userForm;
    for (const field in this.formErrors) {
      if (
        Object.prototype.hasOwnProperty.call(this.formErrors, field) &&
        (field === 'email' || field === 'password')
      ) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          if (control.errors) {
            for (const key in control.errors) {
              if (Object.prototype.hasOwnProperty.call(control.errors, key)) {
                this.formErrors[field] += `${
                  (messages as { [key: string]: string })[key]
                  } `;
              }
            }
          }
        }
      }
    }
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.component.ts